import React, { useState, useEffect } from "react";

import t222 from "../assets/t222.png";

import img6 from "../assets/images_assoc/img6.jpg";
import img7 from "../assets/images_assoc/img7.jpg";
import img5 from "../assets/images_assoc/img5.jpg";
import img8 from "../assets/images_assoc/img8.jpg";

const sections = [
    {
        title: "La culture existe partout",
        text: "Concerts, expos, sport, sorties… la culture vit partout autour de vous, chaque jour.",
        img: img6,
    },
    {
        title: "Nous existons pour ça",
        text: "Thrundrz rassemble tous les événements près de chez vous, en un seul endroit.",
        img: img7,
    },
    {
        title: "Notre but pour les événements",
        text: "Donner de la visibilité aux organisateurs et faire rayonner la scène locale.",
        img: img5,
    },
    {
        title: "La communauté",
        text: "Une communauté qui partage, découvre et vit les événements ensemble.",
        img: img8,
    },
];

const PourquoiSection = () => {
    const [open, setOpen] = useState(false);

    // Bloque le scroll de la page derrière le sheet
    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <section
            id="pourquoi"
            className="
                py-5
                lg:py-5
                px-4
                2xl:px-20
                w-full
                flex
                flex-col
                text-center
                gap-6
                text-white
                bg-black
            "
        >

            {/* ==================================================
                CONTENU PRINCIPAL
            ================================================== */}

            <div className="
                w-full
                max-w-3xl
                mx-auto
                px-4

                text-justify

                font-archivo
                text-white/90

                space-y-6

                text-sm
                sm:text-base

                leading-relaxed
            ">

                <p>
                    Un événement, c'est bien plus qu'une date dans un agenda.
                    C'est un moment suspendu où des inconnus deviennent un
                    public, où une idée prend forme sous les projecteurs,
                    où une ville entière retient son souffle le temps d'un
                    concert, d'une exposition ou d'une rencontre. Qu'il
                    rassemble dix personnes dans une arrière-salle ou plusieurs
                    milliers dans une grande salle, chaque événement porte la
                    même promesse : créer du lien, faire vivre une émotion
                    partagée et laisser un souvenir que l'on raconte longtemps
                    après. C'est cette alchimie unique, impossible à reproduire
                    à l'identique, qui fait toute la magie de l'événementiel.
                </p>

                {/* ==================================================
                    IMAGE CLIQUABLE
                ================================================== */}

                <section className="
                    relative
                    cursor-pointer
                    w-full

                    flex
                    flex-col
                    justify-center
                    items-center

                    font-archivo

                    overflow-hidden
                    rounded-2xl
                ">

                    <button
                        type="button"
                        onClick={() => setOpen(true)}
                        className="
                            relative
                            w-full
                            group
                            focus:outline-none
                        "
                    >

                        <img
                            src={t222}
                            alt="Pourquoi THRUNDRZ"
                            className="
                                w-full
                                h-auto
                                rounded-2xl

                                transition-transform
                                duration-500

                                group-hover:scale-[1.01]
                            "
                        />

                    </button>

                </section>

            </div>

            {/* ==================================================
                OVERLAY
            ================================================== */}

            <div
                onClick={() => setOpen(false)}
                className={`
                    fixed
                    inset-0

                    bg-black/70

                    z-[2000]

                    transition-opacity
                    duration-500

                    ${open
                        ? "opacity-100 pointer-events-auto"
                        : "opacity-0 pointer-events-none"
                    }
                `}
            />

            {/* ==================================================
                FULL SCREEN SHEET
            ================================================== */}

            <div
                className={`
                    fixed
                    inset-0

                    w-full
                    h-full

                    bg-neutral-900

                    z-[2001]

                    transition-transform
                    ease-in-out

                    ${open
                        ? "translate-y-0"
                        : "translate-y-full"
                    }
                `}
                style={{
                    transitionDuration: "600ms",
                }}
            >

                {/* ==================================================
                    ZONE SCROLLABLE
                ================================================== */}

                <div className="
                    relative
                    w-full
                    h-full

                    overflow-y-auto
                    overscroll-contain
                ">

                    {/* ==================================================
                        BOUTON FERMER
                    ================================================== */}

                    <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="
                            absolute

                            top-5
                            right-5

                            z-[2002]

                            text-white

                            bg-white/10
                            hover:bg-white/20

                            rounded-full

                            w-11
                            h-11

                            flex
                            items-center
                            justify-center

                            text-2xl

                            transition-colors

                            shadow-lg
                        "
                        aria-label="Fermer"
                    >
                        ✕
                    </button>

                    {/* ==================================================
                        LES 4 BLOCS
                    ================================================== */}

                    <div className="
                        w-full

                        px-4
                        sm:px-8
                        2xl:px-20

                        pt-20
                        pb-12

                        lg:pt-16

                        flex
                        flex-col

                        gap-12
                        lg:gap-20

                        text-white
                        text-left
                    ">

                        {sections.map((section, index) => (

                            <div
                                key={index}
                                className={`
                                    flex
                                    flex-col
                                    items-center

                                    gap-6
                                    lg:gap-12

                                    ${index % 2 === 1
                                        ? "lg:flex-row-reverse"
                                        : "lg:flex-row"
                                    }
                                `}
                            >

                                {/* ==================================================
                                    TEXTE
                                ================================================== */}

                                <div className="
                                    w-full
                                    lg:w-1/2

                                    flex
                                    flex-col

                                    gap-3
                                    lg:gap-4
                                ">

                                    <h2 className="
                                        font-bold
                                        font-archivo

                                        text-3xl
                                        sm:text-4xl
                                        lg:text-5xl

                                        leading-snug

                                        pr-4
                                    ">
                                        {section.title}
                                    </h2>

                                    {section.text && (
                                        <p className="
                                            font-archivo

                                            text-lg
                                            lg:text-xl

                                            opacity-90

                                            leading-relaxed
                                        ">
                                            {section.text}
                                        </p>
                                    )}

                                </div>

                                {/* ==================================================
                                    IMAGE
                                ================================================== */}

                                <div className="
                                    w-full
                                    lg:w-1/2
                                ">

                                    <img
                                        src={section.img}
                                        alt={section.title}
                                        className="
                                            w-full

                                            h-56
                                            sm:h-72
                                            lg:h-96

                                            object-cover

                                            rounded-2xl

                                            shadow-lg
                                        "
                                    />

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

            </div>

        </section>
    );
};

export default PourquoiSection;